import { Stack, Typography, Grid, MenuItem } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const StyledDataTitle = styled(Typography)`
  width: 100%;
  color: ${theme.palette.primary.main};
`;

export const StyledDataText = styled(Typography)`
  width: 100%;
  font-size: 16px !important;
  margin-bottom: 24px !important;
`;

export const StyledGrid = styled(Grid)`
  margin-bottom: 24px !important;
  @media (max-width: 899px) {
    border-bottom: 1px solid ${theme.palette.secondary.dark};
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;

export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;

export const StyledGridIcons = styled(Grid)`
  display: flex;
  justify-content: left;
  align-items: center;
  & button {
    box-shadow: -2px -2px 15px #dbdbdb, 2px 2px 15px #cacaca;
    margin: 0px 8px;
    padding: 5px;
    & svg {
      border: none !important;
      border-radius: 100%;
      box-shadow: none !important;
      @media (max-width: 700px) {
        font-size: 24px;
      }
    }
    @media (max-width: 700px) {
      margin: 0px 5px;
    }
    @media (max-width: 599px) {
      margin: 10px 8px 0px;
    }
  }
  & :hover {
    box-shadow: inset -2px -2px 5px #dbdbdb, inset 2px 2px 5px #cacaca;
    & button {
      & svg {
        box-shadow: none;
      }
    }
  }
`;

export const StyledContainerBox = styled.div`
  width: 100% !important;
  position: relative !important;
  & .MuiOutlinedInput-root label,
  & .MuiOutlinedInput-root div,
  & .MuiOutlinedInput-root input,
  & .MuiOutlinedInput-root fieldset {
    opacity: 0 !important;
  }
`;

export const StyledUploadBox = styled.div`
  width: 100% !important;
  height: 100% !important;
  color: ${(props) =>
    props.file ? (props.error ? "#d32f2f" : "black") : "rgba(0, 0, 0, 0.6)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px solid
    ${(props) => (props.error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)")};
  border-radius: 5px;
  padding: 5.1px 14px;
  & svg {
    color: ${theme.palette.primary.main};
    font-size: 24px;
    margin: 0px !important;
    padding: 0px !important;
  }
`;

export const StyledChoiceFileText = styled.span`
  max-width: 100% !important;
  color: #333 !important;
  font-size: 17px !important;
  margin: 0px !important;
  padding: 0px !important;
`;

